export const DataTypesOptions: App.SelectOptions[] = [
  { value: "string", label: "String" },
  { value: "boolean", label: "Boolean" },
  { value: "file", label: "File" }
]
